import { useState } from "react";
import { format } from "date-fns";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FieldInput } from "@/components/FieldInput";
import { api, errMsg, inr, todayISO } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useMasters } from "@/hooks/useMasters";

const FIELDS = [
  { name: "transaction_date", label: "Receipt date", type: "date", required: true },
  { name: "transaction_time", label: "Time", type: "time" },
  { name: "payment_mode", label: "Payment Mode", type: "select", options: ["Bank Transfer", "UPI", "Cash", "Other"], required: true },
  { name: "fund_account_id", label: "Bank Account", type: "fund", required: true,
    types: (v) => (v.payment_mode === "Cash" ? ["Cash"] : v.payment_mode === "Other" ? null : ["Bank", "UPI"]) },
  { name: "reference_no", label: "UTR / Reference", type: "text" },
];

export function ReceiveDialog({ row, onClose }) {
  const masters = useMasters();
  const { bump } = useAuth();
  const [v, setV] = useState({ transaction_date: todayISO(), transaction_time: format(new Date(), "HH:mm"), payment_mode: "Bank Transfer", reference_no: row.reference_no || "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!v.fund_account_id) return toast.error("Select bank account");
    setBusy(true);
    try {
      await api.post(`/payouts/${row._txn}/receive`, v);
      toast.success("Payout received — bank balance updated (gain not added again)");
      bump();
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="payout-receive-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Mark Payout Received — {row._txn}</DialogTitle>
          <DialogDescription className="text-xs">Amount {inr(row.credit)}. Sirf bank/cash balance update hoga; virtual credit aur gain pehle hi record ho chuke hain.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-3">
          {FIELDS.map((f) => (
            <FieldInput key={f.name} f={f} value={v[f.name]} values={v} masters={masters} testPrefix="payout-receive"
              onChange={(x) => setV((s) => ({ ...s, [f.name]: x, ...(f.name === "payment_mode" ? { fund_account_id: "" } : {}) }))} />
          ))}
        </div>
        <DialogFooter><Button onClick={save} disabled={busy} data-testid="payout-receive-save">{busy ? "Saving..." : "Mark received"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
